import React from 'react';

export interface QuickLinkType {
  title: string;
  description?: string;
  href: string;
  icon: string;
  external?: boolean;
  as?: React.ElementType;
}

export const QuickLink = ({ title, description, href, icon, external, as: Component }: QuickLinkType) => {
  const Tag = external ? 'a' : (Component ?? 'a');
  const linkProps = Tag === 'a' ? { href, target: external ? '_blank' : '_self' } : { to: href };

  return (
    <Tag
      {...linkProps}
      className="flex gap-5 items-center px-0 py-2 h-full rounded-lg border border-transparent transition-colors sm:p-2 hover:bg-grey-300 hover:border-grey-400 dark:hover:!bg-blue-900 dark:hover:!border-grey-700"
    >
      <div className="grid place-items-center p-3 bg-blue-200 rounded-full h-min">
        <span className="text-2xl leading-none md:text-3xl text-grey-1000 material-symbols-outlined">
          {icon}
        </span>
      </div>
      <div className="flex flex-col">
        <div className={`flex gap-2 items-center`}>
          <p className="text-lg font-bold md:text-xl">{title}</p>
          {external && (
            <span className="text-lg mt-[2px] material-symbols-outlined">open_in_new</span>
          )}
        </div>

        <p>{description}</p>
      </div>
    </Tag>
  );
};
